export const LANDING = '/';
export const SIGN_IN = '/signin';
export const SWITCH_WORKPLACE = '/workplaces';
export const RESET_PASSWORD = '/reset-password';
export const EMAIL_ACTION = '/email-action';
export const NOT_FOUND = '/notfound';
